import { render, staticRenderFns } from "./ProfilesIncomesTable.vue?vue&type=template&id=735b4a72&scoped=true"
import script from "./ProfilesIncomesTable.vue?vue&type=script&lang=js"
export * from "./ProfilesIncomesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735b4a72",
  null
  
)

export default component.exports